import { Box, Chip } from '@mui/material';
import React from 'react';
import { TagCellProps } from 'components/common/grid/';
import { getCellWithTooltip, getIcon } from 'components/common/grid/cell/index';

export default function TagCell({
    modification,
    value,
    items,
    defaultColor = 'primary',
    tooltip,
    t,
    rawTooltipHtml,
    variant,
    pill,
}: TagCellProps) {
    let itemsArr: any[];

    if (modification == 'yes-no') {
        const transformAlias: any = { Y: 'yes', N: 'no' };
        let color = 'default';
        let text = '';
        const aliasValue = value ? transformAlias[value] : undefined;
        if (aliasValue) {
            text = t(aliasValue);
            color = value == 'Y' ? 'success' : defaultColor;
        }
        if ('' == text) text = t(value ?? '');
        itemsArr = [{ text: text, color: color }];
    } else {
        itemsArr = Array.isArray(items) ? items : [];
    }

    const tagElement = (
        <Box>
            {itemsArr
                .filter((tag) => tag.text)
                .map((tag, index) => {
                    const iconEl = getIcon(tag.icon) ?? undefined;
                    const color = tag.color ?? defaultColor;
                    return (
                        <Chip
                            label={tag.text}
                            variant={variant as any}
                            color={color as any}
                            icon={iconEl}
                            sx={pill ? { borderRadius: '10px' } : undefined}
                            key={index + tag.text}
                        />
                    );
                })}
        </Box>
    );

    if (tooltip) {
        return getCellWithTooltip(tagElement, tooltip, rawTooltipHtml, t);
    }

    return tagElement;
}
